import { render, staticRenderFns } from "./UserStaffCreate.vue?vue&type=template&id=7969b686&"
import script from "./UserStaffCreate.vue?vue&type=script&lang=js&"
export * from "./UserStaffCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports